<template>
	<div>
		<header>
			<h1>Offers</h1>
			<div v-if="$can('offer.create')">
				<ul>
					<li><router-link
						:to="{name: 'offers.create'}" class="button button--primary--small">Create Offer</router-link>
					</li>
				</ul>
			</div>
		</header>
		<div>
			<div class="section">
				<loader v-if="!loaded"/>
				<div v-if="loaded && !items.length" class="nothing-to-see-here">
					<p>Nothing to display.</p>
				</div>
				<table v-if="loaded && items.length" role="grid">
					<thead>
						<tr>
							<th align="left">Name</th>
							<th align="left">Expires</th>
							<th align="center">Active</th>
							<th align="center">Approved</th>
							<th align="right" class="actions"><span>Actions</span></th>
						</tr>
					</thead>
					<tfoot>
						<tr>
							<th align="left">Name</th>
							<th align="left">Expires</th>
							<th align="center">Active</th>
							<th align="center">Approved</th>
							<th align="right" class="actions"><span>Actions</span></th>
						</tr>
					</tfoot>
					<tbody>
						<tr v-for="(item, index) in items">
							<td v-html="item.name"/>
							<td v-if="!item.expires_at">—</td>
							<td v-if="item.expires_at" v-html="$present('date', item.expires_at)"/>
							<td align="center">
								<bool-icon :value="item.active"/>
							</td>
							<td align="center">
								<bool-icon :value="item.approved"/>
							</td>
							<td align="right">
								<v-contextual>
									<v-contextual-option
										v-if="$can('update', item)"
										:route-to="{name: 'offers.edit', params: {offer: item.id}}">Edit</v-contextual-option>
								</v-contextual>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>
<script>
import {createNamespacedHelpers} from "vuex";

const {mapState, mapActions, mapMutations} = createNamespacedHelpers("offers");

export default {

	computed: {
		...mapState([
			"columns",
			"items",
			"links",
			"loaded",
			"meta",
			"query",
		]),
	},

	methods: {
		...mapActions([
			"getModels",
		]),
	},

	created() {
		this.getModels();
	},
};
</script>
